import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { discountPercent } from '../data/copy';
import { getOfferDeadline, spotsTakenPercent } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
interface CountdownTimerProps {
  /** Versión corta (sin barra de cupos) para usar dentro de la tarjeta de precio. */
  compact?: boolean;
}

/** Bloque de urgencia que se sitúa justo encima del botón de compra. */
export function CountdownTimer({
  compact = false
}: CountdownTimerProps) {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: hours,
    label: 'horas'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className={`rounded-2xl border border-alert/25 bg-alert-soft text-center ${compact ? 'px-4 py-4' : 'px-5 py-6 sm:px-7'}`} data-id="element-59" data-mp="2zsqgc5zcz2zf">
      <p className="flex items-center justify-center gap-2 font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-alert" data-id="element-60" data-mp="1bzdkuf0ns9yk">
        <AlarmClockIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-61" data-mp="122r1xvrw7sz6" />
        El {discountPercent} de descuento termina en:
      </p>

      {isExpired ? <p className="mt-3 font-display text-lg font-bold leading-snug text-ink" data-id="element-62" data-mp="171u5tcw4zt5k">
          El precio de lanzamiento ya terminó.
        </p> : <>
          <div className={`mx-auto grid max-w-sm grid-cols-3 gap-2 ${compact ? 'mt-3' : 'mt-5 sm:gap-3'}`} aria-hidden="true" data-id="element-63" data-mp="1zqsrgjzgxdfm">
            {units.map(unit => <div key={unit.label} className={`flex flex-col items-center justify-center rounded-xl border border-line bg-shell px-2 text-center ${compact ? 'py-2' : 'py-3'}`} data-id="element-64" data-mp="1l13apgew70u8">
                <span className={`block font-display font-bold leading-none text-ink ${compact ? 'text-2xl' : 'text-3xl sm:text-4xl'}`} data-id="element-65" data-mp="2dp8w85drstv4">
                  {pad(unit.value)}
                </span>
                <span className="mt-1 block font-sans text-[10px] font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-66" data-mp="2sbobz1dklw49">
                  {unit.label}
                </span>
              </div>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-67" data-mp="2jaqbuu6968qy">
            Quedan {hours} horas, {minutes} minutos y {seconds} segundos con el
            precio de lanzamiento.
          </p>

          {compact ? null : <div className="mt-6 border-t border-alert/20 pt-5" data-id="element-68" data-mp="29en6lfg3ttzs">
              <div className="flex items-baseline justify-between gap-4 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-69" data-mp="24mn1z9p3acwv">
                <span data-id="element-70" data-mp="1zobsj02pi4f6">Cupos de lanzamiento</span>
                <span className="text-alert" data-id="element-71" data-mp="1vn0abfm5wlh0">Quedan pocos</span>
              </div>
              <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-shell" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos de lanzamiento tomados" data-id="element-72" data-mp="1qndvj1qoqx63">
                <div className="h-full rounded-full bg-alert" style={{
            width: `${spotsTakenPercent}%`
          }} data-id="element-73" data-mp="16rucb4qrqb3" />
              </div>
              <p className="mt-2 text-right font-sans text-[11px] text-muted" data-id="element-74" data-mp="63iaeygjqlwi">
                {spotsTakenPercent}% de cupos tomados
              </p>
            </div>}
        </>}
    </div>;
}